import React, { useRef } from "react";
import styled from "styled-components";
import { useUser } from "../../context/UserContext";
import Card, { CardElement } from "../Card";
import useMyHandAnimationEffect from "./useMyHandAnimationEffect";

const MyHandElement = styled.div`
  height: var(--bottom-control-bar-height);
  padding: var(--spacing-default);
  overflow-x: auto;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const MyHandScrollTrack = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: max-content;
  margin: auto;
  padding-left: var(--card-width);
  padding-right: var(--card-width);

  & > ${CardElement}:not(:first-child) {
    margin-left: calc(var(--card-width) / 4 * -1);
  }
  & > ${CardElement} {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    flex-grow: 0;
  }
`;

type Props = {
  selected: number[];
  setSelected(next: number[]): void;
};
const MyHand: React.FC<Props> = ({ selected, setSelected }) => {
  const user = useUser();
  const myHandInnerRef = useRef<HTMLDivElement>(null);
  const cachedMyHand = useMyHandAnimationEffect(myHandInnerRef);

  return (
    <MyHandElement ref={myHandInnerRef}>
      <MyHandScrollTrack>
        {cachedMyHand?.cards.map((card, idx) => (
          <Card
            owner={user?.uid}
            key={card._id}
            card={card}
            idx={idx}
            isSelected={selected?.includes(idx)}
            onClick={() => {
              if (selected?.includes(idx)) {
                setSelected(selected.filter((v) => v !== idx));
              } else {
                setSelected([...selected, idx]);
              }
            }}
          />
        ))}
      </MyHandScrollTrack>
    </MyHandElement>
  );
};

export default MyHand;
